import { Icon } from '@sb1/ffe-icons-react';
import { Tooltip } from '@sb1/ffe-form-react';
import { useState } from 'react';
import styles from './organization-statistics.module.less';

const OrganizationStatisticsDonationsCard = ({ iconFileUrl, title, tooltipText, number }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    return (
        <div className={styles.statsBlock}>
            <div className={styles.icon}>
                <Icon fileUrl={iconFileUrl} size="xl" />
            </div>
            <div className={styles.statsBlockText}>
                <div className={styles.statsTitleWithTooltip}>
                    <div className={styles.blockHeader}>{title}</div>
                    <Tooltip aria-controls={title} onClick={() => setTooltipOpen(!tooltipOpen)} />
                </div>
                <div hidden={!tooltipOpen} id={title} className={styles.tooltipText}>
                    {tooltipText}
                </div>
                <div className={styles.blockNumber}>{number}</div>
            </div>
        </div>
    );
};
export default OrganizationStatisticsDonationsCard;
